export default __webpack_public_path__ + "images/assets/499b0666ae66fc3ee2cb26294b592316.svg";